import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { adminCheckSession, adminLogout } from "./adminApi";
import "./AdminDashboard.css";

function getAdminEmail(payload) {
  return (
    payload?.admin_email ||
    payload?.email ||
    payload?.data?.admin_email ||
    payload?.data?.email ||
    ""
  );
}

export default function AdminLayout() {
  const navigate = useNavigate();
  const [adminEmail, setAdminEmail] = useState("");

  useEffect(() => {
    let mounted = true;

    async function loadSession() {
      try {
        const data = await adminCheckSession();

        if (!mounted) return;

        if (data?.authenticated === true) {
          setAdminEmail(getAdminEmail(data));
        } else {
          navigate("/admin/login", { replace: true });
        }
      } catch (err) {
        if (err?.status === 401) {
          navigate("/admin/login", { replace: true });
        }
      }
    }

    loadSession();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  async function handleLogout() {
    try {
      await adminLogout();
    } catch (_) {
      // Redirect even if logout request fails.
    } finally {
      navigate("/admin/login", { replace: true });
    }
  }

  return (
    <div className="admin-shell">
      <div className="admin-nav">
        <NavLink to="/admin" end className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Dashboard
        </NavLink>
        <NavLink to="/admin/users" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Users
        </NavLink>
        <NavLink to="/admin/credit-activity" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Credit Activity
        </NavLink>
        <NavLink to="/admin/chat" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Chat
        </NavLink>
        <NavLink to="/admin/assistant-conversations" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Assistant Conversations
        </NavLink>
        <NavLink to="/admin/corporate-usage" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Corporate Usage
        </NavLink>
        <NavLink to="/admin/corporate-teachers" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Corporate Teachers
        </NavLink>
        <NavLink to="/admin/corporate-schools" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Corporate Schools
        </NavLink>
        <NavLink to="/admin/study-buddy-published-packs" className={({ isActive }) => (isActive ? "admin-nav-active" : "")}>
          Published Study Packs
        </NavLink>
        <div className="admin-nav-spacer" />
        <div className="admin-meta">{adminEmail ? `Signed in as ${adminEmail}` : ""}</div>
        <button
          type="button"
          className="admin-button admin-button-secondary"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>

      <div className="admin-content">
        <Outlet context={{ adminEmail }} />
      </div>
    </div>
  );
}
